<rt-button (click)="fileInput.click()" variant="outline">
  <rt-icon name="file-upload" />
  @if (!avatarFile) {
    <span>{{ 'tlc.current_user.dialog_2fa_sms.user_profile_form.avatar.button' | translate }}</span>
  } @else {
    <rt-truncate class="file-name">{{ avatarFile.name }}</rt-truncate>
  }
</rt-button>
<input
  #fileInput
  (change)="cacheAvatarImg(fileInput.files)"
  accept="{{ DEFAULT_VALID_IMAGE_MIME_TYPES }}"
  type="file"
  hidden
/>

<span class="validation-error">{{ errorMessage }}</span>
